import useInfiniteFetch from '@hooks/useInfiniteFetch';
import batchGroup from '@models/BatchGroup';

const processCourseData = (batchDataFromAPI, isFetching) => {
  const newData = batchDataFromAPI || {};
  newData.results = (newData?.results || []).map((batch) =>
    batchGroup.getEntityData(batch)
  );
  newData.isFetching = isFetching;
  return newData;
};
const useUpcomingBatches = (
  { goalUID, type = 0, limit = 3, groupType = 1 },
  options = { fallbackData: undefined }
) => {
  const key = `v2/batch/batch_group/list/filter/?limit=${limit}&goal_uid=${goalUID}&group_type=${groupType}&class_type_filter=${type}`;
  const {
    data = {},
    isValidating,
    ...rest
  } = useInfiniteFetch(
    key,
    { limit, hasQueryParams: true },
    {
      persistSize: true,
      revalidateFirstPage: true,
      fallbackData: options.fallbackData
    }
  );
  return {
    key,
    isValidating,
    ...rest,
    batchesByFilter: processCourseData(data, isValidating)
  };
};

export default useUpcomingBatches;
